import { VISUALIZATION_SUPPORTED_EXTENSIONS } from '@mentimeter/tiptap/constants';
import {
  isEmptyObject,
  EditorContent as TiptapEditorContent,
  useEditor as useTiptapEditor,
  type EditorContentProps,
} from '@tiptap/react';
import { useEffect } from 'react';

interface VisualizationTextMarkupRendererProps {
  content: Record<string, unknown> | string;
  editorContentProps?: Partial<Omit<EditorContentProps, 'ref'>> | undefined;
}

export const VisualizationTextMarkupRenderer = ({
  content,
  editorContentProps,
}: VisualizationTextMarkupRendererProps) => {
  const editor = useTiptapEditor({
    extensions: VISUALIZATION_SUPPORTED_EXTENSIONS,
    content: isEmptyObject(content) ? '' : content,
    editable: false,
    immediatelyRender: false,
    editorProps: {
      attributes: {
        role: 'none',
      },
    },
  });

  useEffect(() => {
    // TipTap warns if we try to set an empty object as content
    if (!isEmptyObject(content)) {
      editor?.commands.setContent(content);
    }
  }, [content, editor]);

  return <TiptapEditorContent editor={editor} {...editorContentProps} />;
};
